import storage from "@/utils/storage";
import { Button } from "@aidergroup/ui-v2";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

interface Props {
    params: GridRenderCellParams;
}

const ActionsColumn: React.FC<Props> = ({ params: { row } }) => {
    const oid = storage.getItem("oid");
    const navigate = useNavigate();

    const handleOpenReport = () => {
        navigate(`/organizations/${oid}/submissions/${row.sid}/reports/${row.id}`);
    };

    return (
        <Button
            variant="text"
            onClick={handleOpenReport}
            sx={{
                color: "#008BB4",
                "&:hover": {
                    backgroundColor: "rgba(0, 139, 184, 0.1)",
                },
            }}
        >
            <ArrowForwardIcon />
        </Button>
    );
};

export default ActionsColumn;
